import React, { useState } from 'react';
import { 
    Box, 
    Divider, 
    Flex, 
    Heading, 
    Avatar, 
    Text, 
    Badge,
} from '@chakra-ui/react';
import CustomButton from '../../components/ui/buttons/Button';
import ReadOnlyInput from '../../components/ui/forms/ReadOnlyInput';
import CustomEditableInput from '../../components/ui/forms/EditableInput';
import FormSelect from '../../components/ui/forms/FormSelect';

export default function Profile() {
    const [values, setValues] = useState({
        phoneNumber: '+1234567890',
        country: 'Laos, Spain',
        timeZone: 'GMT 21:00 + 1',
        company: 'Keith & Sons',
        emailAddress: 'annajones@ks.com',
    });

    function handleInputChange (event: React.ChangeEvent<HTMLInputElement>) {
        const name = event.target.name;
        const value = event.target.value;

        setValues((prevState) => ({
            ...prevState,
            [name]: value
        }))
    }

    return (
        <Box paddingX={'10'} paddingBottom='10'>
            <Box>
                <Flex paddingTop='0' justifyContent={'space-between'} alignItems='center'>
                    <Heading as='h2' size='lg' marginY={'4'} color='gray.700'>
                        Profile Overview
                    </Heading>
                    <Box>
                        <CustomButton 
                            type='button'
                            cta='outline' 
                            variant={'outline'}
                            size='sm'
                            colorScheme='blue'
                            // onClick={goBackToHome} 
                            label='Update profile' 
                        />
                    </Box>
                </Flex>
                <Divider />
            </Box>
            <Box paddingY={'6'}>
                <Flex>
                    <Avatar name={'Shawn Mendes'} src='' />
                    <Box marginLeft={'2'}>
                        <Text fontSize='md'>
                            Shawn Mendes
                            <Badge ml='1' colorScheme='purple'>
                                ADMIN
                            </Badge>
                        </Text>
                        <Text fontSize={'sm'} color='gray.500'>shawnmendes25@doeoe.com</Text>
                    </Box>
                </Flex>
            </Box>
            <Divider />
            <Box maxW={'md'} marginTop='8'>
                <ReadOnlyInput marginBottom={'6'} label='Company' value={values.company} id='company' />
                <ReadOnlyInput marginBottom={'6'} label='Email address' value={values.emailAddress} id='email' />
                <CustomEditableInput 
                    isEditableButtons={false} 
                    formControlProps={{ marginBottom: '6' }}
                    label='Location' 
                    value={values.country} 
                    id='country' 
                    name='country'
                    onChange={handleInputChange}
                />
                <CustomEditableInput 
                    isEditableButtons={false} 
                    formControlProps={{ marginBottom: '6' }}
                    label='Phone Number' 
                    value={values.phoneNumber} 
                    id='phoneNumber' 
                    name='phoneNumber'
                    onChange={handleInputChange}
                />
                <ReadOnlyInput marginBottom={'6'} label='Time Zone' value={values.timeZone} id='timezone' />
            </Box>
            
            <Box maxW={'md'} marginTop='8'>
                <Heading as='h4' size='md' marginY={'4'} color='gray.600'>
                    Languages
                </Heading>  
                <Divider />
                <FormSelect 
                    formControlProps={{ marginTop: '6' }}
                    list={['French', 'English', "Spanish", "Igbo"]} 
                    id='language' 
                    label='Preferred Language'
                />
            </Box>
        </Box>  
    )
}